import pinSettings from '@/components/pinning/pin-settings/pin-settings.vue';
import PINBOARD_REGISTRY from '@/components/pinning/pinboard-registry.js';

export const MENU = PINBOARD_REGISTRY.map((group) => ({
  page: group.group,
  label: group.label,
  items: group.widgets.map((w) => ({ widget: w.name, label: w.title, side: w.side || 'left' })),
}));

export default {
  components: { pinSettings },
  props: {
    side: { type: String, default: 'left' },
  },
  computed: {
    menu() {
      return PINBOARD_REGISTRY.map((group) => ({
        page: group.group,
        label: group.label,
        items: group.widgets.map((w) => ({ widget: w.name, label: w.title, side: this.side })),
      }));
    },
  },
};
